module.exports = __webpack_public_path__ + "img/loading.61d9036a.svg";